// Frame 08 — app shell, loading (33:2208).
//
// THE TRAP ON THIS FRAME: its `Shell/PageHeader — loading` (33:2341) is a
// hand-built DETACHED copy, and being detached is exactly how it kept a
// failing colour binding through a file-wide token fix. Nothing here reads a
// colour off that node — the eyebrow takes `--accent-on-light` from
// `.maisight-ui-page-header-eyebrow`, the same binding the loaded header uses.
//
// The skeleton boxes ARE the loaded layout's boxes, not lookalikes: this
// borrows `.maisight-ui-page-header*` and `.maisight-ui-stat-tile` from the
// primitives rather than restating their padding and radius, so the body
// cannot settle to a different geometry than it loaded at.

import { Skeleton, SkeletonStack } from "../../ui";
import "./overview.css";

/** Drawn on 33:2341 (title, then two description lines) and 33:2346. */
const HEADER_LINES = [
  { width: 280, height: 28 },
  { width: 620, height: 12 },
  { width: 452, height: 12 },
];
const HEADER_ACTIONS = [96, 128];

/** Heights here are the LOADED tile's own line-heights (Type/labelSm 14,
 *  Type/numLg 30, Type/bodyS 20), not the drawn skeleton's — the drawn
 *  `State/Loading` box is 160 tall against a 112 stat tile, so it was never the
 *  authority on this row's height, and matching the type is what stops the card
 *  below shifting 12px when the numbers land. */
const TILE_LINES = [
  { width: 120, height: 14 },
  { width: 72, height: 30 },
  { width: 168, height: 20 },
];

export function OverviewLoading() {
  // SkeletonStack is the outer element because it carries the `role="status"`
  // region; `.maisight-overview` sits INSIDE it so the loading body inherits the
  // loaded body's 32px section gap rather than the stack's own tighter one —
  // otherwise the stat row settles 20px down the page when the data lands.
  return (
    <SkeletonStack label="Loading overview">
      <div className="maisight-overview">
        <div className="maisight-ui-page-header">
          <div className="maisight-overview-skeleton-lines">
            <p className="maisight-ui-page-header-eyebrow type-labelSm">
              Overview
            </p>
            {HEADER_LINES.map((line) => (
              <Skeleton
                key={line.width}
                width={line.width}
                height={line.height}
              />
            ))}
          </div>
          <div className="maisight-ui-page-header-actions">
            {HEADER_ACTIONS.map((width) => (
              <Skeleton key={width} shape="block" width={width} height={32} />
            ))}
          </div>
        </div>

        <div className="maisight-ui-stat-row">
          {[0, 1, 2].map((tile) => (
            <div key={tile} className="maisight-ui-stat-tile">
              {TILE_LINES.map((line) => (
                <Skeleton
                  key={line.width}
                  width={line.width}
                  height={line.height}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </SkeletonStack>
  );
}
